<template>
  <GlobalWindow
    :title="title"
    :visible.sync="visible"
    v-loading="isUploading"
    :confirm-working="isWorking"
    @confirm="confirm"
  >
    <el-form :model="form" ref="form" label-width="130px" label-suffix="：" :rules="rules" inline>
      <el-form-item label="活动标题" prop="name">
        <el-input v-model="form.name" placeholder="请输入活动标题" v-trim/>
      </el-form-item>
      <el-form-item label="活动分类" prop="labelId">
        <el-select
          v-model="form.labelId"
          placeholder="请选择活动分类"
          filterable
          clearable
        >
          <el-option v-for="item in labels" :key="item.id" :value="item.id" :label="item.name" />
        </el-select>
        <!-- <el-input v-model="form.labelId" placeholder="请输入选择" v-trim/> -->
      </el-form-item>
      <el-form-item label="报名时间" prop="applyTime">
        <el-date-picker
          v-model="applyTime"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm:ss"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="selectApplyTime"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="活动时间" prop="activityTime">
        <el-date-picker
          v-model="activityTime"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm:ss"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="selectActivityTime"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="活动地址" prop="addr">
        <el-input v-model="form.addr" placeholder="请输入活动地址" v-trim/>
      </el-form-item>
      <el-form-item label="经纬度" prop="coordinate">
        <div class="coordinate">
          <el-input v-model="form.longitude" placeholder="请输入经度" v-trim/>
          <div class="spating-line"></div>
          <el-input v-model="form.latitude" placeholder="请输入纬度" v-trim/>
          <div class="spating-line"></div>
          <el-button type="text" @click="getCoordinate">查询</el-button>
        </div>
      </el-form-item>
      <el-form-item label="人数上限" prop="limitnum">
        <el-input v-model="form.limitnum" placeholder="请输入人数上限" v-trim/>
      </el-form-item>
      <el-form-item label="活动价格(元)" prop="price">
        <el-input v-model="form.price" placeholder="请输入活动价格(不填默认免费)" v-trim/>
      </el-form-item>
      <el-form-item label="资讯封面图" prop="imgurlfull">
        <UploadAvatarImage
          :file="{ 'imgurlfull': form.imgurlfull, 'imgurl': form.imgurl }"
          @uploadSuccess="uploadAvatarSuccess"
          @uploadEnd="isUploading = false"
          @uploadBegin="isUploading = true"
        />
      </el-form-item>
      <el-form-item label="活动轮播" prop="fileList">
        <UploadImage
          :fileList="form.fileList"
          @beginUpload="isUploading=true"
          @endUpload="isUploading=false"/>
      </el-form-item>
      <el-form-item label="关联店铺" prop="shopId">
        <div class="coordinate">
          <el-select
            v-model="type"
            placeholder="请选主办方类型"
            filterable
            clearable
            @change="form.shopId='';form.orgId=''"
          >
            <el-option :key="0" value="0" label="商家" />
            <el-option :key="1" value="1" label="机构" />
          </el-select>
          <div class="spating-line"></div>
          <div class="sponsor">
            <el-select
              v-if="type==0"
              v-model="form.shopId"
              placeholder="请输入店铺名称，再选择"
              filterable
              remote
              reserve-keyword
              :remote-method="remoteMethod"
              :loading="searchLoading"
            >
              <el-option
                v-for="item in shops"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <el-select
              v-if="type==1"
              v-model="form.orgId"
              placeholder="请输入机构名称，再选择"
              filterable
              remote
              reserve-keyword
              :remote-method="remoteMethod"
              :loading="searchLoading"
            >
              <el-option
                v-for="item in orgs"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="活动详情" prop="content">
        <RichEditor :content="{ content : form.content}"  @edit="form.content=$event" />
      </el-form-item>
    </el-form>
  </GlobalWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
import RichEditor from '@/components/common/RichEditor'
import UploadImage from '@/components/common/UploadImage'
import UploadAvatarImage from '@/components/common/UploadAvatarImage'
import { fetchList as shopList } from '@/api/business/shop'
import { fetchList as orgList } from '@/api/business/orgs'


export default {
  name: 'OperaActivityWindow',
  extends: BaseOpera,
  components: { GlobalWindow, RichEditor, UploadImage, UploadAvatarImage },
  data () {
    let applyTimeRule = (rule, value, callback) => {
      if (!this.form.signStarttime) {
        callback(new Error('请选择报名开始时间'))
      } else if (!this.form.signEndtime) {
        callback(new Error('请选择报名结束时间'))
      } else {
        callback()
      }
    }
    let activityTimeRule = (rule, value, callback) => {
      if (!this.form.starttime) {
        callback(new Error('请选择开始时间'))
      } else if (!this.form.endtime) {
        callback(new Error('请选择结束时间'))
      } else {
        callback()
      }
    }
    let coordinateRule = (rule, value, callback) => {
      if (!this.form.longitude) {
        callback(new Error('请输入经度'))
      } else if (!this.form.latitude) {
        callback(new Error('请输入纬度'))
      } else {
        callback()
      }
    }
    return {
      
      type: '0',
      isUploading: false,
      searchLoading: false,
      shops: [],
      orgs: [],
      applyTime: [],
      activityTime: [],
      // 表单数据
      form: {
        id: null,
        name: '',
        labelId: '',
        imgurlfull: null,
        imgurl: null,
        shopId: '',
        content: '',
        signEndtime: '',
        signStarttime: '',
        starttime: '',
        endtime: '',
        longitude: '', //经度
        latitude: '', // 纬度
        fileList: [], // 轮播图
        type: 2 //平台活动
      },
      labels: [
        { name: 'a', id: 1 },
        { name: 'b', id: 2 },
        { name: 'c', id: 3 },
      ],
      // 验证规则
      rules: {
        name: [
          { required: true, message: '请输入资讯标题', tigger: 'blur' }
        ],
        labelId: [
          { required: true, message: '请选择资讯分类', tigger: 'change' }
        ],
        imgurlfull: [
          { required: true, message: '请上传资讯主图', tigger: 'change' }
        ],
        limitnum: [
          { required: true, message: '请输入人数上限', tigger: 'blur' }
        ],
        applyTime: [
          { required: true, validator: applyTimeRule, tigger: 'change' }
        ],
        activityTime: [
          { required: true, validator: activityTimeRule, tigger: 'change' }
        ],
        coordinate: [
          { required: true, validator: coordinateRule, tigger: 'blur' }
        ],
      }
    }
  },
  created () {
    this.config({
      api: '/business/activity',
      'field.id': 'id'
    })
  },
  methods: {
    open(title, target) {
      this.title = title
      this.visible = true
      this.shops = []
      this.orgs = []
      this.applyTime = []
      this.activityTime = []
     
      // 新建
      if (target == null) {
        this.$nextTick(() => {
          this.type = '0'
          this.$refs.form.resetFields()
          this.form[this.configData['field.id']] = null
        })
        return
      }
      // 编辑
      this.$nextTick(() => {
        for (const key in this.form) {
          this.form[key] = target[key]
        }
        if (this.form.shopId) {
          this.type = 0
          this.shops = [{ label: target.shopName, id: this.form.shopId }]
        } else {
          this.type = 1
          this.orgs = [{ label: target.orgName, id: this.form.orgId }]
        }
      })
    },
    // 上传图片
    uploadAvatarSuccess(file) {
      this.form.imgurl = file.imgurl;
      this.form.imgurlfull = file.imgurlfull;
    },
   
    selectApplyTime(v) {
      if (!v) {
        this.form.signStarttime = ''
        this.form.signEndtime = ''
      } else {
        this.form.signStarttime = v[0]
        this.form.signEndtime = v[1]
      }
    },
    selectActivityTime(v) {
      if (!v) {
        this.form.starttime = ''
        this.form.endtime = ''
      } else {
        this.form.starttime = v[0]
        this.form.endtime = v[1]
      }
    },
    getCoordinate() {
      window.open('https://lbs.qq.com/getPoint/', '_blank')
    },
    remoteMethod(query) {
      if (query !== '') {
        this.searchLoading = true
        let action = this.type ? orgList : shopList
        action({
          capacity: 999,
          model: {
            name: query
          }
        })
          .then(res => {
            if (this.type) {
              this.orgs = res.records
            } else {
              this.shops = res.records
            }
            
          })
          .finally(() => {
            this.searchLoading = false
          })
      }
    }
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/alertstyle.scss";

::v-deep .el-form-item__content {
  flex: 0.6;
}
.coordinate {
  display: flex;
  .spating-line {
    width: 10px;
  }
}
.sponsor {
  flex: 1;
  ::v-deep .el-select {
    width: 100%;
    .el-input__inner {
      width: 100%;
    }
  }
}
</style>
